import Vue from 'vue';
import VueRouter from 'vue-router';
import Shop from './view/Shop.vue';
import Terminal from './view/Terminal.vue';
import TicketHistory from './view/TicketHistory.vue';
import { GatewaySvc } from './services/gateway.service';
import { GameSvc } from './services/game.service';
import { RulesSvc } from './services/rules.service';
import { ResultsSvc } from './services/results.service';
import { BetSvc } from './services/bet.service';
import { PaytableSvc } from './services/paytable.service';
import { SocketSvc } from './services/socket.service';
import { EventBus } from './utilities/event.bus';
import Ticket from './model/ticket';

let ticket = new Ticket();
Vue.use(VueRouter);
GatewaySvc.init();
GatewaySvc.getGatewaySvc().initialize();
GameSvc.init();
PaytableSvc.init();

let initSocketConnection = () => {
    let gameSvc = GameSvc.getGameSvc();

    SocketSvc.init(sevenConfig);

    // listen for game event and handle it in game service
    EventBus.$on('Keno.GameEvent', event => {
        gameSvc.handleIncomingMessage(event);
    });
};

let createTicket = () => {
    GatewaySvc.getGatewaySvc().sendMessage('Betslip.Create', {
        betslip: {
          tickets: ticket.create()
        }
    });
};

let getPaytable = (reset) => {
    PaytableSvc.getPaytableSvc().getPaytable().then(() => {
      if (reset) {
        EventBus.$emit('Keno.SpotNumberChanged');
      }
    });
};

let setGameRoutes = () => {
  const router = new VueRouter({
    mode: 'history',
    routes: [
      {
        path: '/shop',
        component: Shop
      },
      {
        path: '/retail',
        component: Shop
      },
      {
        path: '/terminal',
        component: Terminal,
      },
      {
        path: '/ticketHistory',
        component: TicketHistory,
      }
    ]
  });

  /**
   * Parent application tells us which part of our app to show
   * @example ['BettingArea', 'TicketHistory']
   */
  EventBus.$on('UI.Show', message => {
    router.push(getRoute(message.data.name[0]));
  });

  const app = new Vue({
      router: router
  }).$mount('#keno-game');
};

const getRoute = (eventName) => {
  let route = '';
  switch (eventName) {
    case 'BettingArea':
      const dp = window.sevenConfig.data.dp.toLowerCase();
      route = {
        path: `/${dp}`
      };
      break;
    case 'TicketHistory':
      route = {
        path: '/ticketHistory'
      };
      break;
    default:
      console.log(`Event ${eventName} is not supported.`)
  }

  return route;
};

EventBus.$on('Keno.ConfigLoaded', () => {
  const pathName = window.location.pathname.split('/')[1].split('?')[0];
  if (pathName === 'ticketHistory') {
    setGameRoutes();
    return;
  }

  initSocketConnection();
  createTicket();
  setGameRoutes();
  getPaytable(true);

  BetSvc.init();
  RulesSvc.init();
  ResultsSvc.init();

  EventBus.$emit('keydown', {
      key: '+'
  });
});

EventBus.$on('Keno.NewConfig', () => {
  const pathName = window.location.pathname.split('/')[1].split('?')[0];
  if (pathName === 'ticketHistory') {
    return;
  }

  getPaytable();
  BetSvc.init();
  RulesSvc.init();
  ResultsSvc.init();
});



// WEBPACK FOOTER //
// main.js